import { useEffect, useRef, useState } from "react";
import "../../css/achievement.css";

const Achievement = () => {
  const [counts, setCounts] = useState([0, 0, 0]);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);
  const stats = [
    {
      value: "10+ Năm",
      title: "Kinh nghiệm",
      desc: ".....",
    },
    {
      value: "10.0000+",
      title: "Khách hàng",
      desc: "..........",
    },
    {
      value: "17.000+",
      title: "Lô hàng",
      desc: "...........",
    },
  ];

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasAnimated(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35, rootMargin: "0px 0px -15% 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!hasAnimated) return undefined;
    const duration = 1200; // ms
    const start = performance.now();
    const targets = stats.map((s) => {
      // Extract only digits and dots from the value
      const numeric = s.value.replace(/[^\d.]/g, "");
      return Number(numeric.replace(/\./g, ""));
    });

    const animate = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = progress * (2 - progress); // ease-out
      const next = targets.map((t) => Math.round(t * eased));
      setCounts(next);
      if (progress < 1) requestAnimationFrame(animate);
    };

    const id = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAnimated]);

  const formatValue = (template, value) => {
    // Extract suffix text (everything that's not a digit or dot or plus)
    const suffixMatch = template.match(/[^\d.+]/g);
    const suffix = suffixMatch ? suffixMatch.join("") : "";
    
    const hasPlus = template.includes("+");
    const useDot = template.includes(".");
    const formatted = useDot
      ? value.toLocaleString("de-DE") // 3.000 style
      : value.toLocaleString("en-US");
    return `${formatted}${hasPlus ? "+" : ""} ${suffix}`.trim();
  };

  return (
    <section className="achievement-section" ref={sectionRef}>
      <div className="achievement-header text-center">
        <h3>HÀNH TRÌNH XUẤT SẮC - MỞ RỘNG KINH DOANH</h3>
        <div>
          Hoạt động vượt trội
        </div>
      </div>
      <div className="achievement-container">
        {stats.map((item, idx) => (
          <div key={item.title} className="achievement-item">
            <div className="achievement-value">
              {formatValue(item.value, counts[idx])}
            </div>
            <div className="achievement-title">{item.title}</div>
            {/* <p className="achievement-desc">{item.desc}</p> */}
            {idx < stats.length - 1 && (
              <span className="achievement-divider" aria-hidden="true"></span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Achievement;
